module.exports = __webpack_public_path__ + "static/media/08B.8a4849f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/08B.png
// module id = 265
// module chunks = 0